import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper } from '@mui/material';
import { DataGrid, GridToolbar, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'
import estilos from '../PanelDetalleCliente/PanelDictamenesComponent.module.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography, TextField, MenuItem, Input, Button, List, ListItemText, ListItem, FormControlLabel, Autocomplete, InputLabel } from '@mui/material';
import moment from 'moment'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
    AgregarDictamenMarcario, ActualizarDictamenMarcario, obtenerDictamenesMarcarioByYear,
    obtenerFolioDictamen, actualizarFolioOficioDictamen, ActualizarMarcaMezcalCliente, ActualizarMarcaBebidasCliente
} from '../../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';
import DeleteIcon from '@mui/icons-material/Delete';
import BotonVerDictamenesComponent from './BotonVerDictamenesComponent';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks';
const styleParaModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 290,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function DictamenMarcarioComponent(props) {

    const { api = undefined } = props
    const { deleteMarcario, handleChangeDictamenMarcario, agregardictamenmarcario, dictamenmarcario } = api

    let marcas = props?.marcas

    const fechaHoy = moment().format('YYYY-MM-DD')
    const dispatch = useDispatch();
    const solicitud = useSelector(store => store.UsuariosAtencionACliente.informacionClienteDictamen)
    const [fechasolicitud, setFechaSolicitud] = useState(fechaHoy);
    const [exportacion, setExportacion] = useState(false);
    const [nacional, setNacional] = useState(false);
    const [usuarioautorizado, setUsuarioMarca] = useState('');
    const [fechaautorizacion, setFechaAutorizacion] = useState('');
    const [fechavigencia, setFechaVigencia] = useState('');
    const [nombretitular, setNombreTitular] = useState('');
    const [tipomarca, setTipoMarca] = useState('');
    const [marca, setMarca] = useState('');
    const [numeroregistro, setNumeroRegistro] = useState('');
    const [numeroexpediente, setNumeroExpediente] = useState('');
    const [clase, setClase] = useState('33');
    const [fechapresentacion, setFechaPresentacion] = useState('');
    const [fechaconcesion, setFechaConcesion] = useState('');
    const [fecharegistro, setFechaRegistro] = useState('');
    const [estatus, setEstatus] = useState('ACTIVA');
    const [tiposolicitud, setTipoSolicitud] = useState('REGISTRO DE MARCA');
    const [leyendasfiguras, setLeyendasFiguras] = useState('');
    const [productosservicios, setProductosServicios] = useState('');
    const [observaciones, setObservaciones] = useState('----------');
    const [conclusiones, setConclusiones] = useState('CON FUNDAMENTO EN EL REGISTRO DE MARCA Y DISEÑO DE ETIQUETAS, LA UNIDAD DE INSPECCIÓN DEL CONSEJO MEXICANO REGULADOR DE LA CALIDAD DEL MEZCAL, A.C. DA POR APROBADO EL USO DE LA PRESENTE MARCA YA QUE SI CUMPLE LO DESCRITO EN LOS APARTADOS 3.1 Y 3.16 DE LA NORMA NOM-070-SCFI-2016. EL USO DE LEYENDAS, FRASES, IMÁGENES, NOMBRES, LOGOTIPOS, CODIGOS DE BARRAS Y OTROS ELEMENTOS NO PREVISTOS EN LA NOM-070-SCFI-2016 PRESENTES EN LAS ETIQUETAS DE ÉSTA MARCA, ESTÁ FUERA DEL ALCANCE DE CERTIFICACIÓN DEL COMERCAM, POR LO QUE SU USO ES RESPONSABILIDAD DEL COMERCIALIZADOR O TITULAR DE LA MARCA.');

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')
    const closeModal = () => setOpenModal(false)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    React.useEffect(async () => {
        if (props?.infodictamen.iddictamenmarcariocliente != null) {
            setFechaSolicitud(moment(props?.infodictamen?.fechasolicitud).add(1, 'd').format('YYYY-MM-DD'))
            setExportacion(props?.infodictamen?.exportacion)
            setNacional(props?.infodictamen?.nacional)
            setUsuarioMarca(props?.infodictamen?.usuarioautorizado)
            setFechaAutorizacion(moment(props?.infodictamen?.fechaautorizacion).add(1, 'd').format('YYYY-MM-DD'))
            setFechaVigencia(moment(props?.infodictamen?.fechavigencia).add(1, 'd').format('YYYY-MM-DD'))
            setNombreTitular(props?.infodictamen?.nombretitular)
            setTipoMarca(props?.infodictamen?.tipomarca)
            setMarca(props?.infodictamen?.marcaregistrada)
            setNumeroRegistro(props?.infodictamen?.numeroregistro)
            setNumeroExpediente(props?.infodictamen?.numeroexpediente)
            setClase(props?.infodictamen?.clase)
            setFechaPresentacion(moment(props?.infodictamen?.fechapresentacion).add(1, 'd').format('YYYY-MM-DD'))
            setFechaConcesion(moment(props?.infodictamen?.fechaconcesion).add(1, 'd').format('YYYY-MM-DD'))
            setFechaRegistro(moment(props?.infodictamen?.fechavigenciaregistro).add(1, 'd').format('YYYY-MM-DD'))
            setEstatus(props?.infodictamen?.estatus)
            setTipoSolicitud(props?.infodictamen?.tiposolicitud)
            setLeyendasFiguras(props?.infodictamen?.leyendasofiguras)
            setProductosServicios(props?.infodictamen?.productosyservicios)
            setObservaciones(props?.infodictamen?.observaciones)
            setConclusiones(props?.infodictamen?.conclusiones)

            /*const objetosDeArchivos = await Promise.all(
                props?.infodictamen?.imgexportacionmarcario?.map(async (dato) => {
                    try {
                        const blob = await cargarImagenBlob(dato.ruta);

                        // Crear un File con el Blob y establecer el nombre y tamaño
                        const file = new File([blob], dato.ruta.split('/').pop(), {
                            lastModified: new Date().getTime(),
                            type: "image/png",
                            size: blob.size, // Establecer el tamaño del archivo en bytes
                        });

                        return file;
                    } catch (error) {
                        // Manejar el error según tus necesidades
                        console.error('Error al crear el objeto File:', error);
                        return null; // Otra opción es retornar null en caso de error
                    }
                })
            );*/
            //setImgExportacion(objetosDeArchivos)
        }
    }, [])
    const cargarImagenBlob = async (url) => {
        try {
            const response = await fetch(url); // Realiza una solicitud HTTP para obtener la imagen
            if (!response.ok) {
                throw new Error('No se pudo cargar la imagen');
            }

            const blob = await response.blob(); // Convierte la respuesta en un Blob

            return blob;
        } catch (error) {
            console.error('Error al cargar la imagen:', error);
            throw error; // Puedes manejar el error según tus necesidades
        }
    }

    const [imgregistrado, setImgRegistrado] = useState([]);
    const handleFileChangeRegistrado = (event) => {
        const imageFiles = Array.from(event.target.files).filter(file =>
            file.type.startsWith('image/')
        );
        setImgRegistrado(imageFiles);
    };
    const handleDeleteRegistrado = (index) => {
        const newSelectedFiles = imgregistrado.filter((file, i) => i !== index);
        setImgRegistrado(newSelectedFiles);
    };

    const [imgnacional, setImgNacional] = useState([]);
    const handleFileChangeNacional = (event) => {
        const imageFiles = Array.from(event.target.files).filter(file =>
            file.type.startsWith('image/')
        );
        setImgNacional(imageFiles);
    };
    const handleDeleteNacional = (index) => {
        const newSelectedFiles = imgnacional.filter((file, i) => i !== index);
        setImgNacional(newSelectedFiles);
    };

    const [imgexportacion, setImgExportacion] = useState([]);
    const handleFileChangeExportacion = (event) => {

        const imageFiles = Array.from(event.target.files).filter(file =>
            file.type.startsWith('image/')
        );

        setImgExportacion(imageFiles);
    };
    const handleDeleteExportacion = (index) => {
        const newSelectedFiles = imgexportacion.filter((file, i) => i !== index);
        setImgExportacion(newSelectedFiles);
    };

    const [openModalDelete, setOpenModalDelete] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalDelete = (dataDictamen) => {
        setOpenModalDelete(true);
        setDataModal(dataDictamen)
    }
    const handleCloseModalDelete = () => setOpenModalDelete(false);
    const modalComponentDelete = () => {
        return (
            <div>
                <Modal
                    open={openModalDelete}
                    onClose={handleCloseModalDelete}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModal}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            <strong>Eliminar Dictamen</strong>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'justify' }}>
                            Está seguro que desea eliminar el dictamen. Esta opción no se podrá revertir.
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                            <strong>¿Desea continuar?</strong>
                        </Typography>
                        <div className='row'>
                            <div className='col-5'>
                                <button className='btn btn-success' onClick={() => DeleteDictamen()}>CONTINUAR</button>
                            </div>
                            <div className='col-1'></div>
                            <div className='col-5'>
                                <button className='btn btn-danger' onClick={() => handleCloseModalDelete()}>CANCELAR</button>
                            </div>
                        </div>
                        <div className='row'>
                        </div>

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const DeleteDictamen = () => {
        deleteMarcario(dataModal)
    }
    const GenerarDictamenMarcario = async () => {
        let registradoimage = true
        if ((tipomarca == 'Mixta' || tipomarca == 'Tridimencional') && imgregistrado?.length == 0) registradoimage = false

        if (((exportacion && imgexportacion?.length > 0) || (nacional && imgnacional?.length > 0)) &&
            usuarioautorizado.length > 0 && fechaautorizacion.length > 0 && fechavigencia.length > 0 &&
            nombretitular.length > 0 && tipomarca.length > 0 && marca.length > 0 && (numeroregistro.length > 0 || numeroexpediente.length > 0) &&
            clase.length > 0 && fechapresentacion.length > 0 && fechaconcesion.length > 0 && fecharegistro.length > 0 &&
            estatus.length > 0 && tiposolicitud.length > 0 && leyendasfiguras.length > 0 && productosservicios.length > 0 &&
            observaciones.length > 0 && conclusiones.length > 0 && registradoimage) {
            await dispatch(actualizarLoadingApp_true())
            var año = moment().format('YYYY');
            let year = String(año)
            let contadorFolio = await dispatch(obtenerDictamenesMarcarioByYear(year))
            let folio = '0001'
            if (contadorFolio?.payload > 0) {
                let obtenerFolio = await dispatch(obtenerFolioDictamen(3))
                const nuevoFolio = ('000' + (parseInt(obtenerFolio?.payload?.folio, 10) + 1)).slice(-4)
                folio = nuevoFolio
            }
            let fecha = new Date(fechaHoy).toISOString()
            let datesolicitud = new Date(fechasolicitud).toISOString()
            let dateautorizacion = new Date(fechaautorizacion).toISOString()
            let datevigencia = new Date(fechavigencia).toISOString()
            let datepresentacion = new Date(fechapresentacion).toISOString()
            let dateconcesion = new Date(fechaconcesion).toISOString()
            let datevigenciaregistro = new Date(fecharegistro).toISOString()
            if (props.infodictamen.iddictamenmarcariocliente == null && props.infodictamen.iddictamenmarcariocliente == undefined) {
                let dataMarcario = {
                    fechasolicitud: datesolicitud, numeroinforme: 'DM-' + folio + '/' + year, exportacion: exportacion, nacional: nacional,
                    nombrerazonsocial: solicitud?.nombrerazonsocial, numerocliente: solicitud?.numerosocio,
                    usuarioautorizado: usuarioautorizado, fechaautorizacion: dateautorizacion,
                    fechavigencia: datevigencia, nombretitular: nombretitular,
                    tipomarca: tipomarca, marcaregistrada: marca,
                    numeroregistro: numeroregistro, numeroexpediente: numeroexpediente,
                    clase: clase, fechapresentacion: datepresentacion,
                    fechaconcesion: dateconcesion, fechavigenciaregistro: datevigenciaregistro,
                    estatus: estatus, tiposolicitud: tiposolicitud, leyendasofiguras: leyendasfiguras,
                    productosyservicios: productosservicios, observaciones: observaciones,
                    conclusiones: conclusiones, idcliente: solicitud?.idcliente,
                    imgregistrado, imgexportacion, imgnacional
                }
                let agregar = await dispatch(AgregarDictamenMarcario(dataMarcario))
                if (datamarca.marca != null && datamarca.marca != undefined) {
                    if (datamarca.marca == marca) {
                        if (datamarca.idmarcasproductocliente != null) {
                            let dataAct = { idmarcasproductocliente: datamarca.idmarcasproductocliente, isdictamenmarcario: true }
                            await dispatch(ActualizarMarcaBebidasCliente(dataAct))
                        }
                        if (datamarca.idmarcascliente != null) {
                            let dataAct = { idmarcascliente: datamarca.idmarcascliente, isdictamenmarcario: true }
                            await dispatch(ActualizarMarcaMezcalCliente(dataAct))
                        }
                    }
                }
                handleChangeDictamenMarcario(agregar.payload)
                setTitleModal("Nuevo dictamen.")
                setBodyModal("El Dictamen Marcario se generó correctamente.")
                setOpenModal(true)
            } else {
                let dataMarcario = {
                    fechasolicitud: datesolicitud, numeroinforme: 'DM-' + folio + '/' + year, exportacion: exportacion, nacional: nacional,
                    nombrerazonsocial: solicitud?.nombrerazonsocial, numerocliente: solicitud?.numerosocio,
                    usuarioautorizado: usuarioautorizado, fechaautorizacion: dateautorizacion,
                    fechavigencia: datevigencia, nombretitular: nombretitular,
                    tipomarca: tipomarca, marcaregistrada: marca,
                    numeroregistro: numeroregistro, numeroexpediente: numeroexpediente,
                    clase: clase, fechapresentacion: datepresentacion,
                    fechaconcesion: dateconcesion, fechavigenciaregistro: datevigenciaregistro,
                    estatus: estatus, tiposolicitud: tiposolicitud, leyendasofiguras: leyendasfiguras,
                    productosyservicios: productosservicios, observaciones: observaciones,
                    conclusiones: conclusiones, idcliente: solicitud?.idcliente,
                    iddictamenmarcariocliente: props?.infodictamen?.iddictamenmarcariocliente,
                    imgregistrado, imgexportacion, imgnacional
                }
                let actualizar = await dispatch(ActualizarDictamenMarcario(dataMarcario))
                if (datamarca.marca != null && datamarca.marca != undefined) {
                    if (datamarca.marca == marca) {
                        if (datamarca.idmarcasproductocliente != null) {
                            let dataAct = { idmarcasproductocliente: datamarca.idmarcasproductocliente, isdictamenmarcario: true }
                            await dispatch(ActualizarMarcaBebidasCliente(dataAct))
                        }
                        if (datamarca.idmarcascliente != null) {
                            let dataAct = { idmarcascliente: datamarca.idmarcascliente, isdictamenmarcario: true }
                            await dispatch(ActualizarMarcaMezcalCliente(dataAct))
                        }
                    }
                }
                handleChangeDictamenMarcario(actualizar.payload)
                setTitleModal("Nuevo dictamen.")
                setBodyModal("El Dictamen Marcario se actualizó correctamente.")
                setOpenModal(true)
            }
            await dispatch(actualizarFolioOficioDictamen({ idfoliodictamen: 3, folio: folio }))

            await dispatch(actualizarLoadingApp_false())
        } else {
            setTitleModal("¡Alerta!")
            setBodyModal("Debe de rellenar todos los campos para poder generar el Dictamen Marcario.")
            setOpenModal(true)
        }
    }
    const [datamarca, setDataMarca] = useState([]);
    const handlerSeleccion = (value) => {
        if (value != null) {
            let tipo = ''
            if (value?.idtipomarca == 1) tipo = 'Mixta'
            if (value?.idtipomarca == 2) tipo = 'Nominativa'
            if (value?.idtipomarca == 3) tipo = 'Tridimencional'

            let titularidad = ''
            if (value.idtitularidaddemarca == 1) titularidad = 'Marca propia'
            if (value.idtitularidaddemarca == 2) titularidad = 'Marca propia en trámite'
            if (value.idtitularidaddemarca == 3) titularidad = 'Marca de licencia de uso autorizado'
            if (value.idtitularidaddemarca == 4) titularidad = 'Marca cesion de derechos autorizada'
            if (value.idtitularidaddemarca == 5) titularidad = 'Marca de licencia autorizado en tramite'
            if (value.idtitularidaddemarca == 6) titularidad = 'Marca cesion de derechos autorizada en trámite'

            if (value.idtitularidaddemarca == 1 || value.idtitularidaddemarca == 3 || value.idtitularidaddemarca == 4) setNumeroRegistro(value?.numeroderegistroimpi)
            if (value.idtitularidaddemarca == 2 || value.idtitularidaddemarca == 5 || value.idtitularidaddemarca == 6) setNumeroExpediente(value?.numeroderegistroimpi)
            setMarca(value?.marca)
            setTipoMarca(tipo)
            setUsuarioMarca(titularidad)
            setDataMarca(value)
        } else {
            setMarca('')
            setNumeroRegistro('')
            setNumeroExpediente('')
            setTipoMarca('')
            setUsuarioMarca('')
        }


    };
    return (
        <div className='container'>

            <div className={`mb-3 ${estilos.divSoloBorderNaranja} row mt-3`}>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <h3>DICTAMEN MARCARIO</h3>
                </div>
                <div className='col-4'>
                    <BotonVerDictamenesComponent tabla={'documentodictamenmarcario'} nombreId={'iddictamenmarcariocliente'} idSolicitud={props?.infodictamen?.iddictamenmarcariocliente} />
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de solicitud" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechasolicitud} onChange={e => setFechaSolicitud(e.target.value)}
                        error={fechasolicitud.length == 0} />
                    {fechasolicitud.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>

                <div className="col-2 mt-3">
                    <FormControlLabel value="top" control={<Checkbox color='success' checked={exportacion} onChange={e => setExportacion(e.target.checked)} />} label="Exportación" labelPlacement="end" />
                </div>

                <div className="col-2 mt-3">
                    <FormControlLabel value="top" control={<Checkbox color='success' checked={nacional} onChange={e => setNacional(e.target.checked)} />} label="Nacional" labelPlacement="end" />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de autorización" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechaautorizacion} onChange={e => setFechaAutorizacion(e.target.value)}
                        error={fechaautorizacion.length == 0} />
                    {fechaautorizacion.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de vigencia" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechavigencia} onChange={e => setFechaVigencia(e.target.value)}
                        error={fechavigencia.length == 0} />
                    {fechavigencia.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Nombre del titular del registro de marca ante el IMPI" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={nombretitular} onChange={e => setNombreTitular(e.target.value)}
                        error={nombretitular.length == 0} />
                    {nombretitular.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={marca}
                        onChange={(event, value = "") => { handlerSeleccion(value); }}
                        onInputChange={(e, value) => { setMarca(value) }} options={marcas?.map((option) => option)} style={{ width: '100%' }}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.marca)}
                        renderInput={(params) => <TextField {...params} label="Marca registrada (IMPI)" InputLabelProps={{ shrink: true }} error={marca.length == 0} />} />
                    {marca.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Tipo de marca" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={tipomarca} onChange={e => setTipoMarca(e.target.value)}
                        error={tipomarca.length == 0} />
                    {tipomarca.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Número de registro" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={numeroregistro} onChange={e => setNumeroRegistro(e.target.value)}
                        error={numeroregistro.length == 0} />
                    {numeroregistro.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4  mt-3">
                    <TextField id="outlined-basic" label="Usuario de la marca registrada por" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={usuarioautorizado} onChange={e => setUsuarioMarca(e.target.value)}
                        error={usuarioautorizado.length == 0} />
                    {usuarioautorizado.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Número de expediente" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={numeroexpediente} onChange={e => setNumeroExpediente(e.target.value)}
                        error={numeroexpediente.length == 0} />
                    {numeroexpediente.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Clase" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={clase} onChange={e => setClase(e.target.value)}
                        error={clase.length == 0} />
                    {clase.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de presentación" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechapresentacion} onChange={e => setFechaPresentacion(e.target.value)}
                        error={fechapresentacion.length == 0} />
                    {fechapresentacion.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de concesión de registro" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechaconcesion} onChange={e => setFechaConcesion(e.target.value)}
                        error={fechaconcesion.length == 0} />
                    {fechaconcesion.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de vigencia del registro" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fecharegistro} onChange={e => setFechaRegistro(e.target.value)}
                        error={fecharegistro.length == 0} />
                    {fecharegistro.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Estatus" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={estatus} onChange={e => setEstatus(e.target.value)}
                        error={estatus.length == 0} />
                    {estatus.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Tipo de solicitud" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={tiposolicitud} onChange={e => setTipoSolicitud(e.target.value)}
                        error={tiposolicitud.length == 0} />
                    {tiposolicitud.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Leyendas o figuras" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={leyendasfiguras} onChange={e => setLeyendasFiguras(e.target.value)}
                        error={leyendasfiguras.length == 0} />
                    {leyendasfiguras.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>
                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Productos y servicios" variant="outlined" style={{ width: '100%' }}
                        InputLabelProps={{ shrink: true, }} value={productosservicios} onChange={e => setProductosServicios(e.target.value)}
                        error={productosservicios.length == 0} />
                    {productosservicios.length == 0 && <span style={{ color: 'red' }}>Campo obligatorio</span>}
                </div>

                {tipomarca != 'Nominativa' ?
                    <div className={`col-md-12 ${estilos.divDiseñoRegistrado} row mt-3`}>
                        <InputLabel htmlFor="file-input"><b>Diseño registrado:</b></InputLabel>
                        <Input type="file" inputProps={{ multiple: true, accept: 'image/*', }} onChange={handleFileChangeRegistrado} style={{ width: '100%' }} id="file-input" />
                        <List> {imgregistrado.map((file, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={file.name} />
                                <img src={URL.createObjectURL(file)} alt={`Preview of ${file.name}`} style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                <IconButton color="secondary" aria-label="delete" onClick={() => handleDeleteRegistrado(index)}  >
                                    <DeleteIcon />
                                </IconButton>
                            </ListItem>
                        ))}
                        </List>
                    </div> : ''
                }

                {exportacion &&
                    <div className={nacional ? `${estilos.divSoloExportacion} row mt-3` : `col-md-12 ${estilos.divNacionalOExportacion} row mt-3`}>
                        <InputLabel htmlFor="file-input"><b>Diseño de etiquetas exportacion:</b></InputLabel>

                        <Input type="file" inputProps={{ multiple: true, accept: 'image/*', }} onChange={handleFileChangeExportacion} style={{ width: '100%' }} id="file-input" />
                        <List> {imgexportacion.map((file, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={file.name} />
                                <img src={URL.createObjectURL(file)} alt={`Preview of ${file.name}`} style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                <IconButton color="secondary" aria-label="delete" onClick={() => handleDeleteExportacion(index)}  >
                                    <DeleteIcon />
                                </IconButton>
                            </ListItem>
                        ))}
                        </List>
                    </div>
                }

                {nacional &&
                    <div className={exportacion ? `${estilos.divSoloNacional} mt-3` : `col-md-12 ${estilos.divNacionalOExportacion} mt-3`}>
                        <InputLabel htmlFor="file-input"><b>Diseño de etiquetas nacional:</b></InputLabel>

                        <Input type="file" inputProps={{ multiple: true, accept: 'image/*', }} onChange={handleFileChangeNacional} style={{ width: '100%' }} id="file-input" />
                        <List> {imgnacional.map((file, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={file.name} />
                                {/*<img src={URL.createObjectURL(file)} alt={`Preview of ${file.name}`} style={{ maxWidth: '100px', maxHeight: '100px' }} />*/}
                                <IconButton color="secondary" aria-label="delete" onClick={() => handleDeleteNacional(index)}  >
                                    <DeleteIcon />
                                </IconButton>
                            </ListItem>
                        ))}
                        </List>
                    </div>
                }

                <div className="col-md-12 mt-3">
                    <TextField id="outlined-basic" label="Observaciones" variant="outlined" style={{ width: '100%' }}
                        value={observaciones} onChange={e => setObservaciones(e.target.value)} />
                </div>
                <div className="col-md-12 mt-3">
                    <TextField id="outlined-basic" label="Conclusiones" variant="outlined" style={{ width: '100%' }}
                        value={conclusiones} onChange={e => setConclusiones(e.target.value)} />
                </div>
                <div className="col-md-6 mt-3">
                    <Button variant="contained" color="success" onClick={() => GenerarDictamenMarcario()}>  Generar Dictamen Marcario </Button>
                </div>
                <div className="col-md-6 mt-3">
                    <Button variant="contained" color="error" onClick={() => handleOpenModalDelete(props?.infodictamen)/*deleteMarcario(props?.infodictamen)*/}>Eliminar</Button>
                </div>
            </div>
            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: 'center' }}>
                        <strong>{titleModal}</strong>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} style={{ textAlign: 'center' }}>
                        {bodyModal}
                    </Typography>
                    <Typography sx={{ mt: 5 }} className='text-center'>
                        <button className='btn btn-success' onClick={closeModal} style={{ width: '60%' }} > Aceptar </button>
                    </Typography>
                </Box>
            </Modal>
            {modalComponentDelete()}
        </div >
    )
}
export default withRouter(DictamenMarcarioComponent)
